// Components
import Grid from "@mui/material/Grid";
import ReportPatientHeader from "src/components/containers/shared/ReportSections/ReportPatientHeader/ReportPatientHeader";
import LegacyVFDetails from "./LegacyVFDetails/LegacyVFDetails";
import LegacyVFColumns from "./LegacyVFColumns/LegacyVFColumns";

// Types
import { IndividualExternalExamType } from "src/services/exams/types";

type LegacyVFExamType = {
  externalExam: IndividualExternalExamType;
};

const LegacyVFExam = ({ externalExam }: LegacyVFExamType) => {
  return (
    <Grid
      className="retinalogik-section"
      container
      item
      xs={12}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <ReportPatientHeader />
      <LegacyVFColumns algorithmType={externalExam?.data?.algorithmType} />
      <LegacyVFDetails vfExam={externalExam} />
    </Grid>
  );
};

export default LegacyVFExam;
